import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-underline-link',
  imports: [NgTemplateOutlet, RouterModule],
  templateUrl: './underline-link.component.html',
  styleUrl: './underline-link.component.scss',
})
export class UnderlineLinkComponent implements OnInit, OnChanges {
  @Input() color?: 'primary' | 'secondary';
  @Input('line-color') lineColor?: 'primary' | 'secondary';
  @Input() size?: 'small' | 'medium' | 'large';
  @Input('font-weight') fontWeight?: '400' | '500' | '600' | '700' = '400';
  @Input() route?: string | any[];
  @Input() params?: { [key: string]: any };
  @Input() fragment?: string;
  @Input() href?: string;
  @Input() target?: string = '';
  @Input() active: boolean = false;
  @Output() clicked: EventEmitter<void> = new EventEmitter<void>();
  public classes: string = '';

  click(): void {
    this.clicked.emit();
  }

  setClasses(): void {
    const classes: string[] = [];
    classes.push('underline-link');
    if (this.size) classes.push(`underline-link--size-${this.size}`);
    if (this.fontWeight) classes.push(`underline-link--font-weight-${this.fontWeight}`);
    if (this.color) classes.push(`underline-link--${this.color}`);
    if (this.lineColor) classes.push(`underline-link--line-${this.lineColor}`);
    if (this.active) classes.push('underline-link--active');
    this.classes = classes.join(' ');
  }

  ngOnInit(): void {
    this.setClasses();
  }

  ngOnChanges(): void {
    this.setClasses();
  }
}
